import { render, staticRenderFns } from "./manutencao.vue?vue&type=template&id=642433dd&scoped=true&"
import script from "./manutencao.vue?vue&type=script&lang=js&"
export * from "./manutencao.vue?vue&type=script&lang=js&"
import style0 from "./manutencao.vue?vue&type=style&index=0&id=642433dd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642433dd",
  null
  
)

export default component.exports